

import React, { useEffect, useRef, useState } from 'react';

import { DashboardLayout, GeneralTable, Dropdown } from "components";
import ic_export from 'assets/images/ic_export.svg';

import 'assets/scss/billingPortal/modules/reporting/revenue.scss';
import { useTableData, useRevenueColumns } from './hooks';
import { Datepicker } from 'components/form/Datepicker';
import moment from 'moment';
import { MoreButton } from 'components/buttons/MoreButton';
import { SubmenuTooltip } from 'components/informational/SubmenuTooltip';
import { exportData } from './hooks/exportData';
import { Button } from 'components/buttons/Button';



export default function Revenue() {
    const selectedMonth = useRef(moment().date(1).format("YYYY-MM-DD"));
    const [inputDate, setInputDate] = useState(moment().date(1).format("YYYY-MM-DD"));

    const {
        getData,
        data, totalRecords,
		isDataLoading,
        isFiltering, setIsFiltering
    } = useTableData({ selectedMonth });

    const columns = useRevenueColumns({ selectedMonth });

    return (
        <div className={"revenue"}>
            <DashboardLayout
                headerTitle={"Revenue Report"}

                bodyClassName={"revenue__body"}
                body={(
                    <GeneralTable
                        className={"body__table"}
                        columns={columns}
                        data={data}
                        minRows={10}

                        getTableData={getData}

                        outerTableHeader={() => {
                            return (
                                <div className={"table__header"}>
                                    <div className={"header__top-section d-flex justify-content-between align-items-center"}>
                                        <div className={"top-section__title tableHeaderTitle "}>
                                            Revenue
                                        </div>

                                        {/* More Actions */}
                                        <SubmenuTooltip
                                            buttonClassName={"top-section__more-actions"}
                                            menuItems={[
                                                {
                                                    icon: ic_export,
                                                    label: "Export",
                                                    onClick: () => exportData(data, selectedMonth.current),
                                                }
                                            ]}
                                        >
                                            <MoreButton
                                                className={"more-actions__icon-wrapper"}
                                                iconClassName={"icon-wrapper__icon"}
                                            />
                                        </SubmenuTooltip>
                                    </div>

                                    <div className={"header__bottom-section d-flex align-items-center"}>
                                        {/* Label */}
                                        <div className={"bottom-section__label d-flex align-items-center"}>
                                            Date
                                        </div>

                                        {/* Input */}
                                        <Datepicker
                                            className={"bottom-section__input-wrapper d-flex align-items-center"}
                                            inputClassName={"input-wrapper__input"}
                    
                                            placeholder={"mm/yyyy"}
                                            defaultDate={inputDate}
                                            handleOnChange={setInputDate}
                                            
                                            dateFormat={"MM/yyyy"}
                    
                                            isConversionRequired_ISO8601 isMonthYear
                                        />

                                        {/* Apply Filter */}
                                        <div className={"bottom-section__apply-filter"}>
                                            <Button
                                                handleOnClick={() => {
                                                    selectedMonth.current = inputDate;
                                                    getData();
                                                    setIsFiltering(true);
                                                }}
                                                isLoading={isFiltering}
                                            >
                                                Search
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            );
                        }}
                        
                        isTableDataLoading={isDataLoading}

                        isUsingPagination
                        totalRecords={totalRecords}

                        isColumnResizeable
                        isTableOddRowsDarken isTableHeightAdjustmentOptional
                    />
                )}
            />
        </div>
    );
}